import { httpRequest } from '@/utils/umiRequest';

// 全局搜索工单数据
export function globalSearchAPI(data: { content: string }, options?: Record<string, any>) {
  return httpRequest.cancelable.post(`/search-bar`, data, options);
}

export async function globalSearchEmailAPI(data: any, options?: Record<string, any>) {
  return await httpRequest.post('/search-bar/email-ticket', data, options);
}

export async function globalSearchSaasAPI(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post('/search-bar/saas-dispute-ticket', params, options);
}
